import React from 'react';
import cn from 'classnames';

import {EEventSource} from 'coreClasses/events/IEvents';

import AddToWishlistButton from 'brandComponents/product/AddToWishlistButton';
import ProductBadges from 'brandComponents/product/ProductBadges';
import ProductMadeToOrder from 'brandComponents/product/ProductMadeToOrder';
import ProductPreOrder from 'brandComponents/product/ProductPreOrder';
import ProductPrice from 'brandComponents/product/ProductPrice';
import Typography from 'brandComponents/Typography';

import ProductDetailPromotions from '../ProductDetailPromotions';

import {IProductDetailDescriptionDataProps} from './IProductDetailDescriptionData';

import styles from './ProductDetailDescriptionData.module.scss';

const ProductDetailDescriptionData = ({
	variationGroup,
	classNames,
	productId,
	selectedProduct,
	isRequiresLoginForRegisteredBannedA,
}: IProductDetailDescriptionDataProps) => {
	const badgesIds = variationGroup.getBadgesIds();
	const isPreorder = variationGroup.isPreorder() || selectedProduct.isPreorder();

	return (
		<div
			className={cn(styles['product-detail__description__data'], 'product-detail__description__data', classNames)}
		>
			{!!badgesIds && (
				<ProductBadges excludeFillVariants className={styles['product-detail__description__badges']} badgesList={badgesIds} />
			)}
			<div className={styles['product-detail__description__name-wrapper']}>
				<Typography classNames={styles['product-detail__description__name']} variant="h1">
					{variationGroup.getName()}
				</Typography>
				<AddToWishlistButton productId={productId} source={EEventSource.PDP} />
			</div>
			<div className={styles['product-detail__description__price-wrapper']}>
				<ProductPrice
					product={variationGroup}
					source={EEventSource.PDP}
					isRequiresLoginForRegisteredBannedA={isRequiresLoginForRegisteredBannedA}
				/>
				<div className={styles['product-detail__description__price-wrapper__tag-wrapper']}>
					{isPreorder && (
						<ProductPreOrder
							classNames={styles['product-detail__description__price-wrapper__tag-wrapper__pre-order']}
						/>
					)}
					{variationGroup.isMadeToOrder() && (
						<ProductMadeToOrder
							classNames={
								styles['product-detail__description__price-wrapper__tag-wrapper__made-to-order']
							}
						/>
					)}
				</div>
			</div>
			<ProductDetailPromotions variationGroup={variationGroup} />
		</div>
	);
};

export default ProductDetailDescriptionData;
